<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Báo cáo hoa hồng tổng hợp'">
          <template v-slot:preview>
            <!-- Header session -->
            <b-row class="mb-5">
              <b-col md="2">
                <date-picker
                  placeholder="Từ ngày"
                  class="form-control-sm"
                  :config="dpConfigs.date"
                  v-model="dpForm.startDate"
                ></date-picker>
              </b-col>
              <b-col md="2">
                <date-picker
                  placeholder="Đến ngày"
                  class="form-control-sm"
                  :config="dpConfigs.date"
                  v-model="dpForm.endDate"
                ></date-picker>
              </b-col>
              <b-col md="3">
                <vue-autosuggest
                  v-model="searchStock"
                  :suggestions="filteredOptions"
                  @selected="onSelected"
                  :limit="10"
                  @input="onInputChange"
                  :input-props="{
                    id: 'autosuggest__input',
                    placeholder: 'Nhập tên cửa hàng',
                  }"
                  ><div
                    slot-scope="{ suggestion }"
                    style="display: flex; align-items: center"
                  >
                    {{ suggestion.item.suggestionName }}
                  </div>
                </vue-autosuggest>
              </b-col>
              <b-col md="2">
                <b-button
                  variant="primary"
                  size="sm"
                  @click="fetchData()"
                  style="fontweight: 600; width: 70px"
                  :disabled="onLoading"
                  >Lọc</b-button
                >
              </b-col>
              <b-col md="2" class="ml-auto">
                <b-dropdown
                  size="sm"
                  id="dropdown-1"
                  right
                  v-if="checkPermission('RR_EXPORT_ALL')"
                >
                  <template slot="button-content">
                    <i style="font-size: 1rem" class="far fa-file-excel"></i>
                    <span class="font-weight-bolder">Xuất dữ liệu</span>
                  </template>
                  <b-dropdown-item
                    @click="reportClick(EXPORT_TYPE.TOTAL)"
                    v-if="checkPermission('RR_EXPORT_ALL')"
                  >
                    <span>
                      <i style="font-size: 1rem" class="far fa-file-excel"></i>
                      &nbsp; Xuất báo cáo tổng hợp</span
                    >
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="reportClick(EXPORT_TYPE.DETAIL)"
                    v-if="checkPermission('RR_EXPORT_ALL')"
                  >
                    <span>
                      <i style="font-size: 1rem" class="far fa-file-excel"></i>
                      &nbsp; Xuất báo cáo chi tiết</span
                    >
                  </b-dropdown-item>
                </b-dropdown>
              </b-col>
            </b-row>
            <!-- End of Header session -->
            <!-- Table session -->
            <b-table
              :items="listItem"
              :fields="fields"
              sort-by="count"
              class="table-bordered table-hover col-md-12"
              :busy="onLoading"
            >
              <template v-slot:table-busy>
                <vcl-table :speed="5" :animate="true" :columns="4"></vcl-table>
              </template>

              <template v-slot:cell(count)="row">
                <div style="text-align: center">
                  <span v-text="row.index + 1" class="text-right"></span>
                </div>
              </template>
              <template v-slot:cell(rewardPoint)="row">
                <div style="text-align: right">
                  <span
                    v-text="formatMoney(row.item.rewardPoint)"
                    class="text-right"
                  ></span>
                </div>
              </template>
              <template v-slot:cell(rewardAdHoc)="row">
                <div style="text-align: right">
                  <span
                    v-text="formatMoney(row.item.rewardAdHoc)"
                    class="text-right"
                  ></span>
                </div>
              </template>
              <template v-slot:cell(bonusPoint)="row">
                <div style="text-align: right">
                  <div
                    class="productCode text-primary"
                    @click="linkToDetail(row.item)"
                    style="cursor: pointer"
                  >
                    <span
                      v-text="formatMoney(row.item.bonusPoint)"
                      class="text-right"
                    ></span>
                  </div>
                </div>
              </template>
              <template v-slot:cell(minusPoint)="row">
                <div style="text-align: right">
                  <div
                    class="productCode text-warning"
                    @click="linkToDetail(row.item)"
                    style="cursor: pointer"
                  >
                    <span
                      v-text="formatMoney(row.item.minusPoint)"
                      class="text-right"
                    ></span>
                  </div>
                </div>
              </template>
              <template v-slot:cell(finalPoint)="row">
                <div style="text-align: right">
                  <span
                    v-text="formatMoney(row.item.finalPoint)"
                    class="text-right"
                  ></span>
                </div>
              </template>
            </b-table>
            <!-- End of Table session -->

            <!-- Paginate session -->
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import ApiService from '@/core/services/api.service';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import moment from 'moment';
import { VueAutosuggest } from 'vue-autosuggest';
import { BASE_URL, EXPORT_STOCK } from '../../../utils/constants';
import { vi } from 'vuejs-datepicker/dist/locale';
import { VclTable } from 'vue-content-loading';
import { showConfirmDialog } from '@/utils/sweet-alert2';
import datePicker from 'vue-bootstrap-datetimepicker';
import { getToastInstance } from '@/utils/toastHelper';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import localData from '@/utils/saveDataToLocal';
import axios from 'axios';
import timeUtils from '@/utils/date';
import { handleError } from '../../../utils/common';

export default {
  data() {
    return {
      dpForm: {
        startDate: timeUtils.getStartOfMonth(),
        endDate: timeUtils.getEndOfMonth(),
      },
      timeUtils,
      dpConfigs: timeUtils.DP_CONFIG,
      onLoading: false,
      disabledDates: {},
      format: 'dd-MM-yyyy',
      language: vi,
      btnCreate: {
        fontWeight: '600!important',
      },
      stocks: [],
      search: '',
      searchStock: '',
      searchId: '',
      store: '',
      searchFromDay: '',
      searchToDay: '',
      type: EXPORT_STOCK,
      fields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: {
            textAlign: 'center',
            fontWeight: 600,
            color: '#181c32',
            width: '3%',
          },
          tdClass: 'sttClass',
        },
        {
          key: 'code',
          label: 'Mã nhân viên',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'fullName',
          label: 'Tên nhân viên',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
        },
        {
          key: 'jobTitleName',
          label: 'Chức vụ',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '14%' },
        },
        {
          key: 'rewardPoint',
          label: 'Điểm thưởng',
          sortable: true,
          thStyle: { fontWeight: 600, color: '#181c32', width: '13%' },
        },
        {
          key: 'bonusPoint',
          label: 'Cộng',
          sortable: true,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'minusPoint',
          label: 'Trừ',
          sortable: true,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'finalPoint',
          label: 'Tổng thưởng',
          sortable: true,
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
        },
      ],
      selected: '',
      options: [
        {
          data: [],
        },
      ],
      filteredOptions: [],
      limit: 10,
      listItem: [],
      EXPORT_TYPE: {
        TOTAL: 'TOTAL',
        DETAIL: 'DETAIL',
      },
    };
  },
  methods: {
    ...getToastInstance(),
    showConfirmDialog,
    fetchStore: async function () {
      this.options[0].data = [];
      ApiService.setHeader();
      ApiService.get('/stores/getStores').then((response) => {
        const stores = response.data.data;
        stores.map((element) => {
          let store = {
            id: element.id,
            name: element.name,
            shortName: element.shortName,
            suggestionName: element.shortName + ' ( ' + element.name + ')',
          };
          this.options[0].data.push(store);
        });
        this.filteredOptions = [{ data: this.options[0].data }];
      });
    },
    editItem: function (item) {
      this.$router.push({
        path: 'export-stocks/update-export-stock',
        query: { id: item.id },
      });
    },
    onSelected(option) {
      this.selected = option.item.id;
      this.searchStock = option.item.name;
    },
    onInputChange(text) {
      if (!text) {
        text = '';
      }
      this.searchStock = text;
      const filteredData = this.options[0].data
        .filter((item) => {
          return (
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, this.limit);

      this.filteredOptions = [
        {
          data: filteredData,
        },
      ];
      //this.fetchStock();
    },
    /**
     * This is what the <input/> value is set to when you are selecting a suggestion.
     */
    getSuggestionValue(suggestion) {
      return suggestion.item.name;
    },
    makeToastSuccess(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'success',
        solid: true,
      });
    },
    makeToastFailed(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'danger',
        solid: true,
      });
    },
    checkPermission: function (condition) {
      return localData.checkPermission(condition);
    },
    reportClick: async function (type) {
      let searchFromDay = this.dpForm.startDate
        ? moment(this.dpForm.startDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
        : '';
      let searchToDay = this.dpForm.endDate
        ? moment(this.dpForm.endDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
        : '';
      let baseUrl = BASE_URL;
      //console.log(baseUrl1);
      if (!searchFromDay) {
        alert('Bạn chưa chọn ngày bắt đầu!');
        return;
      }
      if (!searchToDay) {
        alert('Bạn chưa chọn ngày kết thúc!');
        return;
      }
      if (!this.selected) {
        alert('Vui lòng chọn cửa hàng để xuất báo cáo!');
        return;
      }
      const apiEndPointMap = {
        [this.EXPORT_TYPE.TOTAL]: 'v1/reward-reports/export-excel',
        [this.EXPORT_TYPE.DETAIL]: 'v1/reward-reports/export-excel-detail',
      };
      const endpoint = apiEndPointMap[type];
      let url = `${baseUrl}${endpoint}?fromDate=${searchFromDay}&toDate=${searchToDay}&storeId=${this.selected}`;
      await axios({
        url: url,
        method: 'POST',
        responseType: 'blob',
      })
        .then((response) => {
          let headerLine = response.headers['content-disposition'];
          let startFileNameIndex = headerLine.indexOf('"') + 1;
          let endFileNameIndex = headerLine.lastIndexOf('"');
          let filename = headerLine.substring(
            startFileNameIndex,
            endFileNameIndex,
          );
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', filename);
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch(() => {
          console.log('Xảy ra lỗi khi xuất dữ liệu');
        });
    },
    fetchData: async function () {
      if (this.onLoading) return;
      let searchFromDay = this.dpForm.startDate
        ? moment(this.dpForm.startDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
        : '';
      let searchToDay = this.dpForm.endDate
        ? moment(this.dpForm.endDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
        : '';
      ApiService.setHeader();
      const params = {
        fromDate: searchFromDay,
        toDate: searchToDay,
        storeId: this.selected,
      };
      this.onLoading = true;
      ApiService.query(`v1/reward-reports`, { params })
        .then(({ data }) => {
          this.listItem = data.data;
        })
        .catch((error) => {
          handleError(error);
        })
        .finally(() => {
          this.onLoading = false;
        });
    },
    formatMoney(number) {
      return new Intl.NumberFormat('vn-VN').format(number);
    },
    linkToDetail: function (item) {
      const searchFromDay = this.dpForm.startDate;
      const searchToDay = this.dpForm.endDate;
      const { href } = this.$router.resolve({
        name: 'reward-detail',
        query: {
          fromDate: searchFromDay,
          toDate: searchToDay,
          employeeId: item.id,
          employeeName: item.fullName,
        },
      });
      window.open(href, '_blank');
    },
    isValidDataSettle() {
      if (!this.dpForm.startDate || !this.dpForm.endDate) {
        this.makeToastWarning('Vui lòng chọn ngày bắt đầu, ngày kết thúc!');
        return false;
      }
      if (!this.selected) {
        this.makeToastWarning('Vui lòng chọn cửa hàng!');
        return false;
      }

      const startMoment = moment(this.dpForm.startDate, 'DD/MM/YYYY');
      const endMoment = moment(this.dpForm.endDate, 'DD/MM/YYYY');

      if (
        startMoment.month() !== endMoment.month() ||
        startMoment.year() !== endMoment.year()
      ) {
        this.makeToastWarning(
          'Ngày bắt đầu và ngày kết thúc phải thuộc cùng một tháng và năm!',
        );
        return false;
      }

      if (startMoment.date() !== 1) {
        this.makeToastWarning('Ngày bắt đầu phải là ngày đầu tiên của tháng!');
        return false;
      }

      if (endMoment.date() !== endMoment.daysInMonth()) {
        this.makeToastWarning(
          'Ngày kết thúc phải là ngày cuối cùng của tháng!',
        );
        return false;
      }

      return true;
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Báo cáo hoa hồng tổng hợp', route: 'overview' },
      { title: 'Danh sách báo cáo hoa hồng tổng hợp' },
    ]);
  },
  created() {
    this.fetchStore();
  },
  components: {
    KTCodePreview,
    VueAutosuggest,
    VclTable,
    datePicker,
  },
};
</script>

<style>
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}

input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

select {
  height: 2.5em;
}

.example {
  border: 1px solid #ddd;
  margin-bottom: 2em;
}

code,
pre {
  margin: 1em 0;
  padding: 1em;
  border: 1px solid #bbb;
  display: block;
  background: #ddd;
  border-radius: 3px;
}

.settings {
  margin: 2em 0;
  border-top: 1px solid #bbb;
  background: #eee;
}

/* h5 {
  font-size: 100%;
  padding: 0;
} */

.form-group {
  margin-bottom: 1em;
}

.btn.btn-icon.btn-sm,
.btn-group-sm > .btn.btn-icon {
  height: calc(1.35em + 1.1rem + 2px);
  width: auto;
}

.icon:hover {
  background-color: #90c6fc;
}

.sttClass {
  width: 20px;
}

.autosuggest__results ul {
  list-style: none;
  cursor: pointer;
  margin-bottom: 0;
}

.autosuggest__results {
  position: absolute;
  background-color: #fff;
  z-index: 1;
  width: 100%;
  border: 1px solid #e0e0e0;
  overflow: scroll;
  max-height: 200px;
  position: absolute;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

#autosuggest__input {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #e5eaee;
  border-radius: 0.25rem;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  height: calc(1.35em + 1.1rem + 2px);
  padding: 0.55rem 0.75rem;
  font-size: 0.925rem;
  line-height: 1.35;
  border-radius: 0.28rem;
}

#autosuggest__input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

.autosuggest__results-item:hover {
  background-color: #ddd;
}

.autosuggest__results ul li {
  padding: 8px;
}

.productCode:hover {
  text-decoration: underline;
}
</style>
